<dff-side [observable]="vm$">
  @if (vm$ | async; as vm) {
    <dff-side-titel>{{ vm.sideTitel }}</dff-side-titel>
    <dff-side-tekst [titel]="vm.topOverskrift" [tekst]="vm.topIndhold"></dff-side-tekst>
    <table mat-table [dataSource]="vm.dokumenter" class="mat-elevation-z2">
      <ng-container matColumnDef="overskrift">
        <th mat-header-cell *matHeaderCellDef>Overskrift</th>
        <td mat-cell *matCellDef="let dokument">
          <a [routerLink]="dokument.nr">
            {{ dokument.overskrift }}
          </a>
        </td>
      </ng-container>
      <ng-container matColumnDef="dato">
        <th mat-header-cell *matHeaderCellDef>Dato</th>
        <td mat-cell *matCellDef="let element">
          {{ element.dato | date }}
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="visteKolonner"></tr>
      <tr mat-row *matRowDef="let row; columns: visteKolonner"></tr>
    </table>
  }
</dff-side>
